import { differenceInDays } from 'date-fns';

import DataTable from "react-data-table-component";
import TableLoader from "./TableLoader";

import { EyeIcon, PencilSquareIcon, TrashIcon } from '@heroicons/react/24/outline';

const LabourerDocumentTable = ({ documents, documentCount, isLoading, perPage, onPageChange, onPerPageChange, onUpdateClicked, onDeleteClicked }) => {
  const handleViewDocument = (document) => {
    window.open(document.file, '_blank');
  }

  const columns = [
    {
      name: "Document Type",
      selector: (row) => row.type?.name,
    },
    {
      name: "Expires in",
      selector: (row) => {
        const expirationDate = new Date(row.expirationDate);
        const today = new Date();

        return `${differenceInDays(expirationDate, today)} days`;
      },
    },
    {
      right: "true",
      cell: row => (
        <div className='flex items-center gap-2'>
          <button
            onClick={e => handleViewDocument(row)}
            className='py-1 px-2 text-xs font-semibold cursor-pointer rounded-md bg-ase-blue text-white'
          >
            <EyeIcon className='md:hidden text-white h-3 w-3' />
            <span className='hidden md:block'>View</span>
          </button>

          <button
            onClick={e => onUpdateClicked(row)}
            className='py-1 px-2 text-xs font-semibold cursor-pointer rounded-md bg-ase-blue text-white'
          >
            <PencilSquareIcon className='md:hidden text-white h-3 w-3' />
            <span className='hidden md:block'>Update</span>
          </button>

          <button
            onClick={e => onDeleteClicked(row)}
            className='py-1 px-2 text-xs font-semibold cursor-pointer rounded-md bg-red-600 text-white'
          >
            <TrashIcon className='md:hidden text-white h-3 w-3' />
            <span className='hidden md:block'>Delete</span>
          </button>
        </div>
      )
    }
  ];

  return (
    <DataTable
      columns={columns}
      data={documents}
      highlightOnHover
      striped
      pagination
      paginationServer
      progressPending={isLoading}
      progressComponent={<TableLoader />}
      paginationTotalRows={documentCount}
      paginationRowsPerPageOptions={[1, 5, 10, 20]}
      paginationPerPage={perPage}
      onChangePage={onPageChange}
      onChangeRowsPerPage={onPerPageChange}
    />
  )
}

export default LabourerDocumentTable;